module.exports = __webpack_public_path__ + "media/images/athletes/3578-3dba649640b70e2222053a55db103e26.png";